import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * **Client-side table sort**: copy `<tr>` NodeList to array, sort by selected column `col`, re-`appendChild` in order
 * (moves rows in DOM). Numeric column detected when both cells parse as numbers; else string `localeCompare`.
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'sortable-table',
  category: 'data-table',
  title: 'Sortable table',
  description: 'Click column header to cycle asc/desc on rows.',
  tags: [T.table, T.sort],
  html: `<h2>Rows</h2>

<table id="tbl">
  <thead><tr><th data-k="0" class="s">Name <span id="i0">↕</span></th><th data-k="1" class="s">Qty <span id="i1">↕</span></th></tr></thead>
  <tbody id="tb">
    <tr><td>Beta</td><td>4</td></tr>
    <tr><td>Alpha</td><td>12</td></tr>
    <tr><td>Gamma</td><td>2</td></tr>
  </tbody>
</table>`,
  css: `${shell}

h2 {
  color: var(--nogrok-preview-primary);
  margin: 0 0 1rem;
}

table {
  border-collapse: collapse;
  width: 100%;
  max-width: 28rem;
  font-size: 0.9rem;
}

th,
td {
  border: 1px solid var(--nogrok-preview-outline);
  padding: 0.5rem 0.65rem;
  text-align: left;
}

th {
  background: var(--nogrok-preview-surface-rail);
}

/* Clickable headers — JS attaches listeners to every th.s */
th.s {
  cursor: pointer;
  user-select: none;
}

th.s:hover {
  background: var(--nogrok-preview-selected-tint);
}

/* Zebra assists row tracking after reorder */
tbody tr:nth-child(odd) {
  background: var(--nogrok-preview-surface-container);
}`,
  js: `let col = -1
let dir = 1
const tb = document.getElementById('tb')

document.querySelectorAll('th.s').forEach((th, idx) => {
  th.addEventListener('click', () => {
    if (col === idx) dir = -dir
    else {
      col = idx
      dir = 1
    }
    const rows = [...(tb?.querySelectorAll('tr') || [])]
    // Stable sort not required; appendChild reorders DOM to sorted order
    rows.sort((a, b) => {
      const A = a.cells[col]?.textContent || ''
      const B = b.cells[col]?.textContent || ''
      const n1 = Number(A)
      const n2 = Number(B)
      if (!isNaN(n1) && !isNaN(n2)) return (n1 - n2) * dir
      return A.localeCompare(B) * dir
    })
    rows.forEach((r) => tb?.appendChild(r))
    document.querySelectorAll('th.s span').forEach((s, i) => {
      s.textContent = i === col ? (dir > 0 ? '↑' : '↓') : '↕'
    })
  })
})`,
}

export default preset
